<div class="idp-login-redirect">
    <p>Redirecting to sign-in...</p>
</div>

